<template>
  <div class="flex flex-1">
    <v-layout>
      <v-btn
        v-if="showTransitionToClosedButton"
        style="color: white"
        :color="colorTheme"
        :disabled="isStageTransitionDisabled"
        @click.stop="openStageTransitionConfirmationDialog(stages.CLOSED)"
      >
        Transition to Closed
      </v-btn>
      <v-btn
        v-if="showTransitionToPublishButton"
        :disabled="isStageTransitionDisabled"
        color="warning"
        style="color:white"
        @click.stop="openStageTransitionConfirmationDialog(stages.PUBLISHED)"
      >
        Transition to Published
      </v-btn>
      <v-btn
        v-if="showTransitionToInInsolvencyProceedings"
        :disabled="isStageTransitionDisabled"
        class="danger-button"
        flat="flat"
        @click.stop="openStageTransitionConfirmationDialog(stages.IN_INSOLVENCY_PROCEEDING)"
      >
        Transition to In Insolvency Proceedings
      </v-btn>
      <v-btn
        v-if="showTransitionToDefaulted"
        :disabled="isStageTransitionDisabled"
        color="warning"
        style="color:white"
        @click.stop="openStageTransitionConfirmationDialog(stages.DEFAULTED)"
      >
        Transition to Defaulted
      </v-btn>
    </v-layout>
    <stage-transition-confirmation-dialog
      :dialog="isOpenStageTransitionDialog"
      :cancel-action="closeStageTransitionConfirmationDialog"
      :submit-action="onStageTransitionConfirmed"
      :financial-product="financialProduct"
      :color-theme="colorTheme"
      :error="error"
      :transition-to-stage="transitionToStage"
      :on-custom-field-change="onCustomFieldChange"
      :get-custom-field-value="getCustomFieldValue"
    />
  </div>
</template>

<script>
import Stages from '../../enum/financialProducts/Stages';
import StageTransitionConfirmationDialog from '@/components/financialProducts/StageTransitionConfirmationDialog';

export default {
  name: 'StageTransitionButtons',
  components: { StageTransitionConfirmationDialog },
  props: {
    financialProduct: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
    error: {
      type: String,
      default: '',
    },
    onStageTransitionConfirmed: {
      type: Function,
      required: true,
    },
    unsavedData: {
      type: Boolean,
      default: false,
    },
    onCustomFieldChange: {
      type: Function,
      required: true,
    },
    getCustomFieldValue: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isOpenStageTransitionDialog: false,
      isStageTransitionDisabled: this.unsavedData,
      transitionToStage: '',
      stages: Stages,
    };
  },
  computed: {
    showTransitionToPublishButton() {
      return this.financialProduct.stage === Stages.DRAFT;
    },
    showTransitionToClosedButton() {
      return (this.financialProduct.stage !== Stages.CLOSED && this.financialProduct.stage !== Stages.DEFAULTED);
    },
    showTransitionToInInsolvencyProceedings() {
      return (this.type === 'product' && this.financialProduct.stage === Stages.PUBLISHED);
    },
    showTransitionToDefaulted() {
      return (this.type === 'product' && this.financialProduct.stage === Stages.IN_INSOLVENCY_PROCEEDING);
    },
  },
  watch: {
    unsavedData(val) {
      this.isStageTransitionDisabled = val;
    },
  },
  methods: {
    openStageTransitionConfirmationDialog(transitionToStage) {
      this.transitionToStage = transitionToStage;
      this.isOpenStageTransitionDialog = true;
    },
    closeStageTransitionConfirmationDialog() {
      this.transitionToStage = '';
      this.isOpenStageTransitionDialog = false;
    },
  },
};
</script>

<style scoped>
  .danger-button {
    border: 0.1px solid lightgray;
    min-width: 100px;
    min-height: 36px;
    border-radius: 5px;
    color: red;
    float: right;
  }
  .danger-button:hover {
    background-color: red;
    color: white !important;
    border-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/financialProducts/StageTransitionButtons.vue